module.exports = __webpack_public_path__ + "static/media/login_logo.633fd337.svg";